import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SearchResults from "@/pages/SearchResults";

export const Route = createFileRoute("/es/buscar")({
  head: () => buildRouteHead("/es/buscar"),
  component: SearchResults,
});

